import { ISanityImage, ISanityItemOption } from '@rbi-ctg/menu';

export interface IAddExtrasContentItemProps {
  index: number;
  itemName: string;
  onChange(index: number): void;
  itemPrice: number;
  itemImage?: ISanityImage;
  itemOption?: ISanityItemOption;
  subtitle?: string;
  itemCalories?: string;
  max?: number;
  isInCart?: boolean;
  maxAmount?: number;
}

export enum AddExtraItemControlType {
  NUMBER_INPUT,
  CHECKBOX,
}
